module.exports = __webpack_public_path__ + "static/training4-8014804e01c2589d09b1ee26df6605d9.jpg";